/** Sale-list channel for browser storefront (matches backoffice price-list rules). */
export const STOREFRONT_PRICING_CHANNEL = 'web' as const;
